import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faGlobeAfrica } from '@fortawesome/free-solid-svg-icons'

const IconGlobe = () => <span><FontAwesomeIcon icon={faGlobeAfrica} /></span>

export default IconGlobe